import React from 'react'
import NoImage from '../images/person.png'
import { IMAGE_BASE_URL, POSTER_SIZE} from '../../config'
import {StyledActor} from '../styles/StyledActor'

const Actor = ({actor}) => {
    return (
        <StyledActor>
            <img
                src = {actor.profile_path ? `${IMAGE_BASE_URL}${POSTER_SIZE}${actor.profile_path}` : NoImage}
                alt = "actor"
            />
            <span className="actor-name">{actor.name}{actor.character && " as "}</span>
            <span className="actor-character">{actor.character}</span>
        </StyledActor>
    )
}

export default Actor
